import { IoArrowBack } from "react-icons/io5";
import "../css/SuggestionList.css";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { useLocation } from "react-router-dom";
import { useAtom } from "jotai";
import {
  consultationJSONAtom,
  // openMedicineModalAtom,
} from "../../new_consultation/constants/_constant";
// import { useItemsFilter } from "../../_helper/actions/app/items";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

// const ComplaintsData = [
//   { id: 1, name: "Cold" },
//   { id: 2, name: "Cough" },
//   { id: 3, name: "Neck Pain" },
//   { id: 4, name: "Anxiety" },
//   { id: 5, name: "Pain" },
// ];

const SuggestionList = ({
  autoFocus = false,
  setIsSuggestion,
  handleSearch,
  searchInput,
  selectedData,
  handleAddData,
  checkDuplicate,
  setOpenMedicineModal,
  setMedicineData,
  medicineData,
  openMedicineModal,
  medicineID,
  isLoading = false,
  currLabel,
  customData,
  setcustomField,
  addictions,
  setAddictions,
  allergies,
  setAllergies,
  patientHistory,
  setPatientHistory,
  billingServices,
  setBillingServices,
}) => {
  const location = useLocation();
  const [consultationJSON] = useAtom(consultationJSONAtom);
  const searchParams = new URLSearchParams(location.search);
  const step = searchParams.get("step");
  const [checkedData, setCheckedData] = useState([]);
  const [isCustomInput, setIsCustomInput] = useState(false);
  const lowercaseLabel = consultationJSON[step]?.label
    ?.replace(/\s+/g, "")
    ?.toLowerCase();

  // Use useEffect to initialize checkedData only once when the component mounts
  useEffect(() => {
    if (lowercaseLabel === "addictions") {
      setCheckedData([...checkedData, ...addictions]);
    } else if (lowercaseLabel === "allergy") {
      setCheckedData([...checkedData, ...allergies]);
    } else if (lowercaseLabel === "patienthistory") {
      setCheckedData([...checkedData, ...patientHistory]);
    } else if (lowercaseLabel === "billing") {
      setCheckedData([...checkedData, ...billingServices]);
    } else {
      setCheckedData([...checkedData, ...customData]);
    }
  }, []);

  const handleCheckedData = (e, data) => {
    if (e.target.checked) {
      const modifiedData = checkDuplicate(data);

      if (lowercaseLabel === "billing") {
        const isAlreadyExist = billingServices?.findIndex(
          (adc) => adc?.id === data?.id
        );
        if (isAlreadyExist === -1) {
          const service = {
            id: data.id,
            discount: 0,
            discount_type: "percentage",
            price: data?.price,
            type: "Amt",
            description: data?.name_of_service,
            quantity: 1,
            sub_lines: [],
            uom: "",
            total: data?.price,
            line_service: data?.id,
            line_package: null,
          };

          setCheckedData((prev) => {
            const alreadyExists = prev.some(
              (ele) => ele?.id === service.id && ele?.step === step
            );

            //("alreadyExists", alreadyExists);

            if (!alreadyExists) {
              return [...prev, { ...service, step: step }]; // Add only if not already in the array
            }
            return prev; // Return unchanged if it already exists
          });
        }
        //("CUSTOM FIELD DATA", customData);
      }

      if (modifiedData && lowercaseLabel !== "billing") {
        // Check if the item already exists in checkedData
        setCheckedData((prev) => {
          const alreadyExists = prev.some(
            (ele) => ele?.id === modifiedData.id && ele?.step === step
          );

          //("alreadyExists", alreadyExists);

          if (!alreadyExists) {
            return [...prev, { ...modifiedData, step: step }]; // Add only if not already in the array
          }
          return prev; // Return unchanged if it already exists
        });
      }

      if (
        consultationJSON[step]?.key === "medicineTable" &&
        !openMedicineModal
      ) {
        setOpenMedicineModal(true);
        medicineID(modifiedData.id);
      }
    } else {
      // Remove the medicine from the checked list
      setCheckedData((prev) => prev?.filter((ele) => ele?.id !== data?.id));

      // Remove the medicine from medicineData in MobileConsultation
      setMedicineData((prev) =>
        prev?.filter((medicine) => medicine?.id !== data?.id)
      );
    }
  };

  const closeSuggestion = () => {
    setCheckedData([]);
    setIsSuggestion();
  };

  const getIsChecked = (id) => {
    // let checkedArr = [];
    let isExist;
    if (currLabel === "medicineTable") {
      isExist = medicineData?.findIndex((ele) => ele?.id === id);
    } else {
      if (consultationJSON[step]?.tagId) {
        isExist = checkedData?.findIndex(
          (ele) =>
            ele?.id === id &&
            ele?.tag_type?.includes(consultationJSON[step]?.tagId)
        );
      } else {
        isExist = checkedData?.findIndex((ele) => ele?.id === id);
      }
    }
    if (isExist > -1) {
      return true;
    } else {
      return false;
    }
  };

  const addData = () => {
    if (checkedData?.length > 0) {
      // setCheckedData([]);
      handleAddData(checkedData);
      setCheckedData([]);
    } else {
      toast.error("Choose at least one option");
    }
  };
  //("CUSTOM DATA", checkedData);

  //console.log(lowercaseLabel);

  // Allow user to add new data
  const handleAddCustomData = () => {
    if (
      lowercaseLabel === "addictions" ||
      lowercaseLabel === "patienthistory" ||
      lowercaseLabel === "allergy"
    ) {
      const data = {
        id: Date.now(), // Generate a unique ID for the custom item
        name: searchInput, // Use the input as the name of the custom item
        value: searchInput,
        type: "new",
      };
      handleAddData([...checkedData, data]);
      setCheckedData([]);
    } else if (lowercaseLabel === "medicinedetails") {
      setOpenMedicineModal(true);
    } else {
      const customDataItem = {
        id: Date.now(), // Generate a unique ID for the custom item
        name: searchInput, // Use the input as the name of the custom item
        value: searchInput,
        tag_type: [consultationJSON[step]?.tagId],
        type: "new",
      };

      // setCheckedData((prev) => [...prev, { ...customDataItem, step: step }]);
      handleAddData([...checkedData, customDataItem]);
      setCheckedData([]);
      // toast.success(`${searchInput} added successfully`);
    }
  };

  return (
    <div className="cu-mobile-consultation-suggestion-list-main">
      <div className="cu-mobile-consultation-suggestion-list-header">
        <div className="flex items-center gap-4">
          <span>
            <IoArrowBack size={25} onClick={closeSuggestion} />
          </span>
          <span className="text-xl text-[#000000]">
            {`Select ${consultationJSON[step]?.label}`}
          </span>
        </div>
        {/* <IoIosCheckmarkCircle
          size={25}
          color={`${checkedData?.length > 0 ? "#57D08B" : "#8B8B8B"}`}
          onClick={() => addData(checkedData)}
        /> */}
      </div>

      {/* Icon in the bottom right corner */}
      <div className="fixed right-4 bottom-4 z-50">
        <IoIosCheckmarkCircle
          size={50} // Increased size for better visibility
          color={`${checkedData?.length > 0 ? "#57D08B" : "#8B8B8B"}`}
          onClick={() => addData(checkedData)}
          className="cursor-pointer"
        />
      </div>
      <div className="px-[10px] relative w-full">
        <input
          className="cu-mobile-consultation-suggestion-list-input border"
          placeholder={`Search ${consultationJSON[step]?.label}`}
          onChange={(e) => {
            handleSearch(e);

            const inputValue = e.target.value;
            // Check if the input value exists in the selectedData array
            const isPresent = selectedData?.some(
              (item) => item.name.toLowerCase() === inputValue.toLowerCase()
            );

            // Set if it's a custom input when the input is not found in the selectedData
            setIsCustomInput(!isPresent && inputValue.length > 0); // Ensure no empty string is treated as custom
          }}
          value={searchInput}
          autoFocus={autoFocus}
        />
        {isLoading && (
          <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
            <div className="loader h-7 w-7 border-2 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
      </div>

      {isCustomInput && searchInput && selectedData?.length == 0 && (
        <div className="flex justify-left items-center mt-4 ml-4">
          <button
            className="bg-[#4CAF50] hover:bg-[#388E3C] text-white font-semibold py-2 px-4 rounded-lg transition duration-300 ease-in-out"
            onClick={handleAddCustomData}
          >
            Add "{searchInput}"
          </button>
        </div>
      )}
      <div className="cu-mobile-consultation-suggestion-list">
        {selectedData?.map((item) => (
          <div
            className="cu-mobile-consultation-suggestion-list-item"
            key={item?.id}
          >
            <span className="cu-mobile-consultation-suggestion-list-text">
              {consultationJSON[step]?.key !== "medicineTable" && item?.name}

              {consultationJSON[step]?.key === "medicineTable" &&
                item?.medicine_name}
              {consultationJSON[step]?.offset === "CLINIC_SERVICES" &&
                item?.description}
            </span>
            <span className="cu-mobile-consultation-suggestion-list-checkbox">
              <input
                type="checkbox"
                className="w-6 h-6"
                checked={getIsChecked(item?.id)}
                onChange={(e) => handleCheckedData(e, item)}
              />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuggestionList;
